module.exports = require("redux-immutable");


//////////////////
// WEBPACK FOOTER
// external "redux-immutable"
// module id = 380
// module chunks = 0